const finderScripts = [
  'nomacare-product-finder-config.js',
  'nomacare-product-finder-core.js',
  'nomacare-product-finder-flow.js',
  'nomacare-product-finder-matching.js',
  'nomacare-product-finder-results.js',
  'nomacare-product-finder-init.js',
];

window.__nomacareFinderAssetsPromise ||= (async () => {
  for (const filename of finderScripts) {
    await new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = new URL(filename, import.meta.url).href;
      script.defer = true;
      script.onload = resolve;
      script.onerror = () => reject(new Error(`Unable to load ${filename}`));
      document.head.append(script);
    });
  }
})();

window.__nomacareFinderAssetsPromise.catch((error) => {
  console.error('NomaCare Product Finder failed to initialise.', error);
});
